const video     = document.getElementById("box4-video");
const container = document.getElementById("box4-video-box");

if (video && container) {
  video.load();

  const isIPad        = /iPad/.test(navigator.userAgent) || (navigator.maxTouchPoints > 0 && /Macintosh/.test(navigator.userAgent));
  const isAndroidTab  = /Android/.test(navigator.userAgent) && window.innerWidth >= 768;
  const isTablet      = isIPad || isAndroidTab;
  const isMobile      = !isTablet && /iPhone|iPod|Android/i.test(navigator.userAgent);

  if (isTablet) {
    ScrollTrigger.create({
      trigger: '.box4',
      start: 'top bottom',
      once: true,
      onEnter: () => {
        video.play().catch(() => {});
        container.classList.add('active');
      }
    });

  } else {
    const proxy = { time: 0 };

    let videoUnlocked = !isMobile;
    let unlocking = false;

    const GESTURES = ["touchstart", "pointerdown", "click", "keydown"];

    function unlockVideo() {
      if (videoUnlocked || unlocking) return;
      unlocking = true;

      if (video.readyState === 0) video.load();

      const p = video.play();

      if (p === undefined) {
        finishUnlock();
        return;
      }

      p.then(finishUnlock).catch(() => {
        unlocking = false;
      });
    }

    function finishUnlock() {
      video.pause();
      videoUnlocked = true;
      unlocking = false;

      GESTURES.forEach(evt => document.removeEventListener(evt, unlockVideo));

      video.currentTime = proxy.time;
    }

    if (isMobile) {
      GESTURES.forEach(evt =>
        document.addEventListener(evt, unlockVideo, { passive: true })
      );
    }

    function init() {
      const duration = video.duration;

      gsap.to(proxy, {
        time: duration,
        ease: "none",
        scrollTrigger: {
          trigger: '.box4',
          start: "bottom bottom",
          end: '+=60%',
          pin: true,
          scrub: 0,
          onUpdate: () => {
            if (!videoUnlocked) return;
            if (Math.abs(video.currentTime - proxy.time) > 0.01) {
              video.currentTime = proxy.time;
            }
          },
          onToggle: (self) => {
            container.classList.toggle("active", self.isActive);
          }
        }
      });
    }

    if (video.readyState >= 1) {
      init();
    } else {
      video.addEventListener("loadedmetadata", init, { once: true });
    }
  }
}


const box3    = document.querySelector('.box3');
const box3Tab = document.querySelectorAll('.item-switch-but li');

if (box3 && box3Tab.length) {
  const box3Splide = new Splide('#box3-splide', {
    type      : 'fade',
    perPage   : 1,
    arrows    : false,
    rewind    : true,
    pagination: false,
    drag      : false,
  }).mount();

  const box3BgColors = [
    'linear-gradient( #E3E1DB 0%, #F6F4F0 50%, #F6F4F0 100%)',
    'linear-gradient( #D5D6DA 0%, #F6F4F0 50%, #F6F4F0 100%)',
    'linear-gradient( #ACACAE 0%, #F6F4F0 50%, #F6F4F0 100%)',
    'linear-gradient( #E7DFCD 0%, #F6F4F0 50%, #F6F4F0 100%)',
  ];

  function switchBox3Tab(index) {
    box3Tab.forEach(item => item.classList.remove('active'));
    box3Tab[index].classList.add('active');
    box3Splide.go(index);
    if (box3BgColors[index]) {
      box3.style.backgroundImage = box3BgColors[index];
    }
  }

  box3Tab.forEach((item, index) => {
    item.addEventListener('click',     () => switchBox3Tab(index));
    item.addEventListener('mouseover', () => switchBox3Tab(index));
  });
}


const box6Tab = document.querySelectorAll('.box6 .right .text-list .text-item');

if (document.getElementById('box6-splide')) {
  const box6Splide = new Splide('#box6-splide', {
    type   : 'fade',
    perPage: 1,
    gap    : 10,
    arrows : true,
    rewind : true,
  }).mount();

  if (box6Tab.length) {
    box6Splide.on('move', () => {
      const activeIndex = box6Splide.index;
      box6Tab.forEach(item => item.classList.remove('active'));
      box6Tab[activeIndex].classList.add('active');
    });
  }
}


const box8Tab   = document.querySelectorAll('.box8-content .tab-click .item');
const box8Text  = document.querySelectorAll('.box8-content .tab-text .item');
const box8Img   = document.querySelectorAll('.box8 .bg-img>div');
const box8TabHr = document.querySelector('.box8-content .tab-click .hr');

if (box8Tab.length && box8Text.length && box8Img.length && box8TabHr) {
  function switchBox8Tab(index) {
    box8Tab.forEach(item => item.classList.remove('active'));
    box8Text.forEach(item => item.classList.remove('active'));
    box8Img.forEach(item => item.classList.remove('active'));
    box8Text[index].classList.add('active');
    box8Img[index].classList.add('active');
    box8Tab[index].classList.add('active');
    box8TabHr.style.transform = `translateX(${index * 100}%)`;
  }

  box8Tab.forEach((item, index) => {
    item.addEventListener('click',     () => switchBox8Tab(index));
    item.addEventListener('mouseover', () => switchBox8Tab(index));
  });
}


if (document.getElementById('box9-splide')) {
  new Splide('#box9-splide', {
    type        : 'loop',
    perPage     : 1.5,
    focus       : 'center',
    lazyLoad    : 'nearby',
    updateOnMove: true,
    arrows      : true,
    breakpoints : {
      1024: {
        perPage: 1.5
      },
      750: {
        perPage: 1
      },
    }
  }).mount();
}
